export class BadRequestError extends Error {
  readonly type: string;
  constructor() {
    super('Bad request.');
    this.type = 'BadRequestError';
  }
}
